// pinSegment usa el orden interno del legacy a,f,b,g,e,c,d (no alfabético), el mismo en que
// renderRows dibuja las filas del display. No reordenarlo.

export const defaultPinDigit = () => [
  { pin: 9, state: false },
  { pin: 10, state: false },
  { pin: 11, state: false },
  { pin: 12, state: false },
];

export const defaultPinSegment = () => (
  Array.from({ length: 7 }, () => ({ pin: 0, state: false }))
);

export const SEGMENT_LETTERS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];

export const SEGMENT_LETTER_TO_INDEX = {
  a: 0, f: 1, b: 2, g: 3, e: 4, c: 5, d: 6,
};

// CargarNumero() del firmware pide los pines/estados en orden físico a,b,c,d,e,f,g.
export const PHYSICAL_ORDER = SEGMENT_LETTERS.map((letter) => SEGMENT_LETTER_TO_INDEX[letter]);
